<template>
    <v-container>
      <v-data-table
        :headers="headers"
        :items="datos"
        item-key="dateTime"
      >
        <template v-slot:[`item.dateTime`]="{ item }">
          <span>{{ item.dateTime }}</span>
        </template>
        
        <template v-slot:[`item.field.id`]="{ item }">
          <span>{{ item.field.id }}</span>
        </template>
  
        <template v-slot:[`item.field.value`]="{ item }">
          <span>{{ item.field.value }}</span>
        </template>
      </v-data-table>
    </v-container>
  </template>
  
  <script>
  export default {
    props: {
        datos: Array,
        headers: Array,
    },
    data() {
      return {
      };
    }
  };
  </script>
  
  <style scoped>
  /* Puedes agregar estilos personalizados aquí si lo deseas */
  </style>
  